import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../speakEasy.css";
import "./rules.css";
import { setBackButtonUrl } from "../uiSlice";
import { getDvSourceImageUrl } from "../../functions/themeAssets";
import useUnlockPageScroll from "../useUnlockPageScroll";

/** Player rules page from old/rules.php: logo, custom title, rules list, Next -> categories. */
export default function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector((s) => s.theme);

  useUnlockPageScroll();

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch]);

  if (themeStatus === "loading" && !themeData) {
    return (
      <div className="quiz-loader-container">
        <div className="quiz-loader" />
      </div>
    );
  }

  const rules = Array.isArray(themeData?.rules)
    ? themeData.rules.map((r) => String(r || "").trim()).filter(Boolean)
    : [];

  return (
    <div className="se-page se-rules-page">
      {themeData?.logo ? (
        <div className="se-rules-logo">
          <img src={getDvSourceImageUrl(themeData.logo)} alt="" />
        </div>
      ) : null}

      {themeData?.sub_title ? (
        <h3 className="se-title" style={{ color: themeData.landing_page_title_color }}>
          {themeData.sub_title}
        </h3>
      ) : null}

      <ul className="se-rule-list" style={{ color: themeData?.sub_title_color }}>
        {rules.map((rule, i) => (
          <li key={i}>{rule}</li>
        ))}
      </ul>

      <button type="button" className="se-btn se-rules-next" onClick={() => navigate("/category")}>
        <span>Next</span>
        <i className="fa-solid fa-angles-right se-btn-icon" aria-hidden="true" />
      </button>

      <div className="se-rotate-overlay" aria-hidden>
        Please rotate your device for the best experience
      </div>
    </div>
  );
}
